import { Group, Text } from '@mantine/core';
import { WorkflowProperty } from './OnOffBadge';

export const AttributeRow = ({ label, value }: { label: string; value: string }) => {
  return (
    <Group grow gap='xs' w='100%'>
      <Text size='sm' c='gray.6'>
        {label}
      </Text>
      <WorkflowProperty text={value} />
    </Group>
  );
};
